module.exports = __webpack_public_path__ + "assets/img/pt-52a6a0f4.png";